/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:29
 * @LastEditTime: 2022-11-15 18:14:57
 * @FilePath: \web-app\src\network\other\customization.js
 * @Environment: Vue + Element
 * @Description: 定制管理
 */
import {
    request,
} from '../request.js'

// 列表
export function customizationList(data) {
    return request({
        url: '/web/back/sys/payDetail/list',
        method: 'post',
        data
    })
}
